import {
	DataGridPro,
	GridToolbarColumnsButton,
	GridToolbarDensitySelector,
	GridToolbarExport,
	GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import React from "react";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteConfirmationDialog from "../Dialogs/DeleteConfirmationDialog";

const CustomToolbar = ({ chosenFields, isAdmin, handleDeleteItems }) => {
	return (
		<GridToolbarContainer>
			<Box sx={{ display: "flex", gap: 1 }}>
				{isAdmin && !chosenFields?.length > 0 && (
					<>
						<GridToolbarFilterButton />
						<GridToolbarColumnsButton />
						<GridToolbarDensitySelector />
						<GridToolbarExport />
					</>
				)}

				{chosenFields && chosenFields?.length > 0 && (
					<DeleteConfirmationDialog
						header="Delete Confirmation"
						title="Are you sure you want to delete these parameters?"
						description="This will remove them from any product items and their templates."
						response={() => handleDeleteItems()}
					>
						{(showDialog) => (
							<Tooltip
								title='Delete'
								arrow
								sx={{ py: 0 }}
							>
								<IconButton
									color='error'
									onClick={showDialog}
								>
									<DeleteIcon fontSize={"small"} />
								</IconButton>
							</Tooltip>
						)}
					</DeleteConfirmationDialog>
				)}
			</Box>

			<Box sx={{ marginLeft: "auto" }}>
				<GridToolbarQuickFilter />
			</Box>
		</GridToolbarContainer>
	);
};

const ExistingParametersDataGrid = ({
	fields,
	setField,
	loading,
	chosenFields,
	columns,
	isAdmin,
	rowModesModel,
	handleRowModesModelChange,
	setRows,
	setRowModesModel,
	handleDeleteItems,
}) => {
	return (
		<Box
			sx={{
				"& .new-param-theme--header": {
					color: "white",
				},
				height: 500,
			}}
		>
			<DataGridPro
				columns={columns}
				rows={fields}
				initialState={{
					density: 'compact',
				}}
				rowModesModel={rowModesModel}
				onRowModesModelChange={handleRowModesModelChange}
				onRowSelectionModelChange={(newRowSelectionModel) => {
					setField(newRowSelectionModel);
				}}
				slots={{
					toolbar: CustomToolbar,
				}}
				checkboxSelection
				loading={!!loading}
				slotProps={{
					toolbar: {
						setRows,
						setRowModesModel,
						handleDeleteItems,
						chosenFields,
						isAdmin,
						csvOptions: {
							disableToolbarButton: !isAdmin,
						},
						printOptions: {
							disableToolbarButton: !isAdmin,
						},
						showQuickFilter: true,
					},
					loadingOverlay: {
						variant: "skeleton",
						noRowsVariant: "skeleton",
					},
				}}
			/>
		</Box>
	);
};

export default ExistingParametersDataGrid;
